<template>
    <fieldset  :lang="app.state.lang" :class="fieldsetCssClass" >
        <label v-if="props.labelTx"   :for="id"   class="label-s text-upper-1st">{{tx.t(props.labelTx) }}</label>

        <label v-if="props.icon" :for="id" class="group-text icon" :title="hintText">
            <span :class="props.icon" aria-hidden="true"></span>
        </label>

        <label v-if="props.labelBeforeTx" :for="id" class="group-text text-upper-1st" >{{tx.t(props.labelBeforeTx)}}</label>

        <select class='select'
            ref="select"
           :value="props.modelValue"
           @input="updateValue"
           :id="id"
           v-bind="$attrs"
           >
           <option v-if="placeholderTx"  value="" style="display:none">{{tx.t(placeholderTx)}}</option>
           <option v-if="!(null===allValue || undefined===allValue)"  :value="allValue" >{{tx.t(allTx)}}</option>
           <slot/>
           <template v-for="item in items2" :key="item.id" >
            <option :value="item.id">
            {{ tx.t(item.name) }}
        </option>
        </template>
      
    </select>
        <label v-if="labelAfterTx" :for="id" class="group-text  " >{{tx.t(labelAfterTx)}}</label>
        <slot name="after"/>
    </fieldset>
</template>

<script>
export default {
  inheritAttrs: false,
}
</script>
<script setup>
import ui from '@/app/ui.js';
import { nextTick, onMounted, ref } from 'vue';
import tx from '@/app/tx';
import app from '@/app/app';
import api from "@/app/api";
import { stringLiteral } from '@babel/types';
import { computed } from '@vue/reactivity';

defineExpose({updateItems});
const props = defineProps({
    modelValue: null,
    placeholderTx: String,
    labelTx:String,
    labelBeforeTx:String,
    labelAfterTx:String,
    items:Object||String,
    fieldsetCss:String,
    icon:String,
    id:String,
    allValue:null,
    allTx:{type:String, default:"All"}
});


const id=ref(props.id?props.id:ui.getUid());
const items2=ref({});
const emit = defineEmits(['update:modelValue'])

const select=ref();

function updateValue (event) {
    emit('update:modelValue', event.target.value)
}
 function updateItems(items){
    items2.value=items;
 }
onMounted(changeVal);

async function changeVal(){

    if(typeof(props.items) ==="string"){
        let response = await api.call('GET',props.items);
        items2.value=JSON.parse(response.data);
    }
    if(typeof(props.items) ==="object"){
        items2.value=props.items;
    }

}
const fieldsetCssClass= computed(() => {
    let out = props.fieldsetCss;
    if (props.icon || props.labelBeforeTx || props.labelAferTx)
        out += ' group-input';
    return out;
})

const hintText = computed(() => {
    if (props.placeholderTx) return tx.t(props.placeholderTx);
    if (props.labelTx)       return tx.t(props.labelTx);
    if (props.labelBeforeTx) return tx.t(props.labelBeforeTx);
    if (props.labelAfterTx)  return tx.t(props.labelAfterTx);
    return '';
})



</script>